<span [matTooltipDisabled]="!disabled" matTooltip="Resource is empty">
  <button
    ctx-button--secondary
    font="mono"
    [disabled]="disabled"
    actionIcon="VIEW_IN_MODAL"
    (click)="launch()"
    size="sm"
  >
    {{ viewLabel }}
  </button>
</span>
